import type { RuleNames } from "./feature-names";

/**
 * Le nom français de chaque règle de l'entreprise, cherché par son ruleId (les
 * règles n'ont pas de nom : voir shared/src/rules/types.ts), et de chaque
 * catégorie de règles. Une règle ou une catégorie sans nom est une erreur de
 * compilation, ici et dans chaque autre langue.
 */
export const rulesFr: RuleNames = {
  rules: {
    REFUND_OWNER_APPROVAL_ABOVE_RULE: "Accord du propriétaire au-delà de",
    ID_IMAGE_RETENTION_RULE: "Conservation des images d'identité",
    FIRST_REPLY_TARGET_RULE: "Délai de première réponse",
    INTERIM_SUSPENSION_REVIEW_RULE: "Revue d'une suspension provisoire",
    UNANSWERED_JOB_EXPIRY_RULE: "Expiration d'une demande sans réponse",
    SUBSCRIPTION_GRACE_PERIOD_RULE: "Délai de grâce d'un abonnement",
    STAFF_SESSION_INACTIVITY_RULE: "Déconnexion après inactivité",
  },
  categories: {
    payments: "Paiements",
    support: "Dossiers",
    safety: "Confiance & sécurité",
    onboarding: "Vérification",
    jobs: "Demandes",
    access: "Accès",
  },
};
